import { Link, useParams } from 'react-router-dom';
import { BlogCta } from '@/components/BlogCta';
import { NotFound } from '@/pages/NotFound';
import { findArticle, formatArticleDate, renderMarkdown } from '@/lib/blog';
import { useLangHref, useT } from '@/lib/useLang';

export function BlogPost() {
  const t = useT();
  const { slug } = useParams();
  const withLang = useLangHref();
  const article = slug ? findArticle(slug) : undefined;

  if (!article) return <NotFound />;

  return (
    <>
      <article className="nz-article">
        <Link className="nz-article__back" to={withLang('/blog')}>
          {t.blogBack}
        </Link>

        <div className="nz-article__meta">
          <time dateTime={article.date}>{formatArticleDate(article.date, article.lang)}</time>
          <span aria-hidden="true">·</span>
          <span>
            {article.readingMinutes} {t.blogMinutes}
          </span>
        </div>

        <h1 className="nz-article__title">{article.title}</h1>
        <p className="nz-article__desc">{article.description}</p>

        {article.cover && (
          // Décorative : le titre juste au-dessus dit déjà de quoi parle l'article.
          <img className="nz-article__cover" src={article.cover} alt="" width={1600} height={900} />
        )}

        {/*
          Le HTML vient de nos propres fichiers markdown, versionnés dans le
          dépôt — jamais d'une saisie utilisateur ni d'une base. Les articles de
          DispatchSEO sautent la relecture LLM, mais seulement sans HTML brut
          ni lien `javascript:` (garde de pr-adversarial-review.yml). Si un jour
          le contenu vient d'ailleurs, il faut un assainissement avant cette
          ligne : `marked` ne nettoie rien.
        */}
        <div className="nz-prose" dangerouslySetInnerHTML={{ __html: renderMarkdown(article.markdown) }} />
      </article>

      <BlogCta />
    </>
  );
}
